import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';

import { useSelector, useDispatch } from 'react-redux';
import { setSelectedTrip, selectedTripSelector, setShowTripReport } from '../../../features/tripcenter/tripControlSlice';
import { cancelTrip, getOneTrip, getTripLog, tripReprocess, resetTrip, forceCompleteTrip } from '../../../features/tripcenter/tripsApi';
import { selectSelectedRoute, setSelectedRoute } from '../../../features/tripcenter/routeSlice';
import { userSelector } from '../../../features/user/UserSlice';
import { setDetailView, removeDetailView } from '../../../features/assets/assetsSlice';
import {
    ListItem, Typography,
    Box, Stack,
    Tooltip,
    Divider, IconButton
} from '@mui/material';

import Icon from '@mdi/react';
import {
    mdiRoutes,
    mdiHexagon,
    mdiWater,
    mdiListStatus, mdiCog, mdiFileChart, mdiCloseCircle

} from '@mdi/js';
import CancelTripDialog from './CancelTripDialog';
import TripLogModal from './TripLogModal';
import TripDataViewModal from './TripDataViewModal';
import TripSettingsModal from './TripSettingsModal';
import RouteDetailView from '../routeViewComponents/RouteDetailView';
import ForceCompleteTripDialog from './ForceCompleteTripDialog';

const TripListItem = React.memo(({ tripData, expandedTripId, setExpandedTripId }) => {
    const dispatch = useDispatch();
    const selectedTrip = useSelector(selectedTripSelector);
    const trip = tripData && tripData._id === expandedTripId ? selectedTrip ? selectedTrip : tripData : tripData;
    const user = useSelector(userSelector);
    const { isAdmin } = user;
    const [openCancelDialog, setOpenCancelDialog] = useState(false);
    const [tripToCancel, setTripToCancel] = useState(null);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [dataViewOpen, setDataViewOpen] = useState(false);
    const [settingsModalOpen, setSettingsModalOpen] = useState(false);
    const [routeDetailOpen, setRouteDetailOpen] = useState(false);
    const selectedRoute = useSelector(selectSelectedRoute);
    const [isCancelling, setIsCancelling] = useState(false);
    const [forceCompleteDialogOpen, setForceCompleteDialogOpen] = useState(false);
    const [tripToForceComplete, setTripToForceComplete] = useState(null);
    const [isForceCompleting, setIsForceCompleting] = useState(false);
    const routeNameParts = trip?.route?.routeName?.split('|') || [];
    const routeDisplayName = routeNameParts[0] || trip?.route?.routeName || 'Unknown Route';
    const routeTypeLabel = routeNameParts[1] || '';
    const isRoundTrip = /round\s*trip/i.test(routeTypeLabel);

    const formatDateTime = (dateString) => {
        const gmtDate = moment.utc(dateString);
        const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
        return istDate.format("DMMM");
    };

    const getISTDateTime = (dateString) => {
        const gmtDate = moment.utc(dateString);
        const istDate = gmtDate.clone().add(5, 'hours').add(30, 'minutes');
        return istDate.format("DMMM, h:mm a");
    };

    useEffect(() => {
        if (expandedTripId === trip._id) {
            //console.log("Original trip data", tripData);
            //console.log("Selected tripId", selectedTrip?._id);
            //console.log("#TripListItem Selected Trip", selectedTrip);
            console.log("#The Trip: ", selectedTrip?._id, {
                tripId: selectedTrip?._id,
                truckRegistrationNumber: selectedTrip?.truckRegistrationNumber,
                created: selectedTrip?.createdAt,
                updated: selectedTrip?.updatedAt,
                backDated: selectedTrip?.backDated,
                plannedStartTime: getISTDateTime(selectedTrip?.plannedStartTime),
                plannedStartTimeGMT: selectedTrip?.plannedStartTime,
                actualStartTime: getISTDateTime(selectedTrip?.actualStartTime),
                actualEndTime: getISTDateTime(selectedTrip?.actualEndTime),
                actualEndReason: selectedTrip?.actualEndReason,
                tripName: selectedTrip?.tripName,
                tripPath: selectedTrip?.tripPath?.length,
                lastCheckTime: selectedTrip?.lastCheckTime ? moment(selectedTrip?.lastCheckTime).format('DD-MM-YYYY HH:mm') : "nocheck",
                lastPathMetricsCheck: selectedTrip?.lastPathMetricsCheck || "nopathcheck",
                lastCheckResult: selectedTrip?.lastCheckResult,
            });

            //console.log("trip item showing", trip);
        }
    }, [trip, expandedTripId, tripData, selectedTrip]);

    const showTripOnMap = useCallback((trip) => {
        if (trip._id === expandedTripId) {
            console.log("#TripListem: Close trip on map", trip.truckRegistrationNumber, trip._id, trip.deviceImei);
            dispatch(setSelectedTrip(null));
            setExpandedTripId(null);
            //handleDataViewClose();
            dispatch(setShowTripReport(false));
            dispatch(setSelectedRoute(null));
            dispatch(setDetailView(null));
        } else {
            console.log("#TripListem: Show trip on map", trip.truckRegistrationNumber, trip._id, trip.deviceImei)
            setExpandedTripId(trip._id);
            dispatch(setSelectedTrip(trip));
            dispatch(getOneTrip({ _id: trip._id }));
            dispatch(setSelectedRoute(trip?.route));
            //handleDataViewOpen();
            if (trip?.tripStage === 'Start Delayed' || trip?.tripStage === 'Active') {
                dispatch(setDetailView(trip.deviceImei));
            } else {
                dispatch(setDetailView(null));
            }
            //console.log("trip shown", trip);
        }
    }, [expandedTripId, dispatch, setExpandedTripId]);

    const handleCancelClick = (trip) => {
        if (openCancelDialog && tripToCancel?._id === trip._id) return;

        setTripToCancel(trip);
        setOpenCancelDialog(true);
    };

    const handleCancelClose = () => {
        setOpenCancelDialog(false);
        setTimeout(() => {
            setTripToCancel(null);
        }, 100);
    };

    const handleConfirmCancel = async (reason) => {
        if (!tripToCancel || !reason || isCancelling) return;

        try {
            setIsCancelling(true);
            await dispatch(cancelTrip({
                trip: tripToCancel,
                reason: reason
            }));
            handleCancelClose();
        } finally {
            setIsCancelling(false);
        }
    };

    const handleShowLog = () => {
        if (!trip) return;
        //filename = `${truckRegNumber}-${day}${month}.log`;
        const filename = `${trip.truckRegistrationNumber}-${moment(trip.plannedStartTime).format('DDMMM')}`;
        dispatch(getTripLog(filename));
        console.log("Showing log", filename);
        setLogModalOpen(true);
    };

    const handleDownloadLog = () => {
        if (!trip) return;
        const filename = `${trip.truckRegistrationNumber}-${moment(trip.plannedStartTime).format('DDMMM')}`;
        dispatch(getTripLog(filename)).then((action) => {
            if (action.payload?.logContent) {
                const blob = new Blob([action.payload.logContent], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `trip_log_${filename}.csv`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        });
    };

    const handleReprocess = () => {
        console.log("Reprocessing trip", trip.tripId, trip.truckRegistrationNumber);
        dispatch(tripReprocess({ _id: trip._id }));
    };

    const handleResetTrip = () => {
        console.log("Resetting trip", trip.tripId, trip.truckRegistrationNumber);
        dispatch(resetTrip({ trip }));
    };

    const handleRouteDetailOpen = (routeid) => {
        console.log("RouteDetailOpen", routeid);
        dispatch(setSelectedRoute(trip?.route));
        setRouteDetailOpen(true);
        console.log("RouteDetailOpen", trip?.route?.routeName);
    };

    const handleRouteDetailClose = () => {
        dispatch(setSelectedRoute(null));
        setRouteDetailOpen(false);
    };

    const handleDataViewOpen = () => {
        setDataViewOpen(true);
    };


    const handleDataViewClose = () => {
        setDataViewOpen(false);
    };

    const handleSettingsOpen = () => {
        setSettingsModalOpen(true);
    };

    const handleSettingsClose = () => {
        setSettingsModalOpen(false);
        dispatch(setShowTripReport(false));
    };

    const handleForceCompleteClick = (trip) => {
        if (forceCompleteDialogOpen && tripToForceComplete?._id === trip._id) return;

        setTripToForceComplete(trip);
        setForceCompleteDialogOpen(true);
    };

    const handleForceCompleteClose = () => {
        setForceCompleteDialogOpen(false);
        setTimeout(() => {
            setTripToForceComplete(null);
        }, 100);
    };

    const handleConfirmForceComplete = async (tripData) => {
        if (!tripToForceComplete || !tripData?.reason || isForceCompleting) return;

        try {
            setIsForceCompleting(true);
            console.log("Force completing trip", tripToForceComplete._id, tripData);
            await dispatch(forceCompleteTrip({
                tripId: tripToForceComplete._id,
                startTime: tripData.startTime,
                endTime: tripData.endTime,
                endReason: tripData.reason
            }));
            handleForceCompleteClose();
        } finally {
            setIsForceCompleting(false);
        }
    };
    //console.log("Trip issues", trip.truckRegistrationNumber, trip?.issues?.issueString);
    return (
        <>
            <ListItem
                sx={{
                    borderRadius: 0.5,
                    mb: 0.15,
                    boxShadow: 1,
                    bgcolor: trip._id === selectedTrip?._id ? 'midnightblue' : 'background.paper',
                    '&:hover': {
                        bgcolor: trip._id === selectedTrip?._id ? 'midnightblue' : '#f5f5f5',
                        filter: trip._id === selectedTrip?._id ? 'brightness(1.1)' : 'brightness(0.98)',
                    },
                    padding: 2,
                    position: 'relative',
                    transition: 'all 0.2s ease',
                    '& .registration-number': {
                        color: trip._id === selectedTrip?._id ? 'white' : 'text.primary',
                        fontWeight: 'bold'
                    },
                    '& .fuel-efficiency': {
                        color: trip._id === selectedTrip?._id ? 'white' : 'Navy',
                        fontSize: '0.7rem'
                    },
                    '& .route-name': {
                        color: trip._id === selectedTrip?._id ? 'white' : 'navy',
                        fontWeight: 'bold'
                    },
                    '& .location-name': {
                        color: trip._id === selectedTrip?._id ? 'white' : 'text.primary'
                    },
                    '& .active-status': {
                        color: trip._id === selectedTrip?._id
                            ? 'white'
                            : trip?.activeStatusColor
                    },
                    '& .trip-stage': {
                        color: trip._id === selectedTrip?._id
                            ? 'white'
                            : trip?.stageColor,
                        opacity: trip._id === selectedTrip?._id ? 1 : 1
                    },
                    '& .violations': {
                        color: trip._id === selectedTrip?._id
                            ? '#FFCDD2'
                            : 'red'
                    },
                    '& .rules-good': {
                        color: trip._id === selectedTrip?._id
                            ? '#B9F6CA'
                            : 'green'
                    }
                }}
            >
                <Stack direction="column" spacing={0.5} sx={{ width: '100%' }}>
                    <Box
                        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', gap: 1 }}
                        onClick={() => showTripOnMap(trip)}
                        style={{ cursor: 'pointer' }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 0
                            }}>
                                <Typography variant="body1" className="registration-number" sx={{ fontSize: '0.8rem', marginTop: 1, marginBottom: 0.1 }}>
                                    <b style={{ cursor: 'pointer', textDecoration: 'underline' }}>{trip.truckRegistrationNumber}</b>
                                    {trip?.fuelEfficiency ?
                                        <span className="fuel-efficiency">
                                            <Icon
                                                path={mdiWater}
                                                size={0.6}
                                                style={{
                                                    marginLeft: '4px',
                                                    marginRight: '2px',
                                                    verticalAlign: 'middle',
                                                    color: trip._id === selectedTrip?._id ? 'white' : 'Navy'
                                                }}
                                            />
                                            {trip?.fuelEfficiency?.toFixed(1)} Km/L
                                        </span>
                                        : null
                                    }
                                </Typography>
                                <Typography variant="body1" className="registration-number" sx={{ fontSize: '0.8rem', marginTop: 0, marginBottom: 0.3 }}>

                                    {
                                        trip?.lastCheckTime && isAdmin &&
                                        <span style={{ color: 'gray', fontSize: '0.6rem', ml: 1 }}>
                                                {moment.parseZone(trip.lastCheckTime).format('DMMM h:mm a')} | {trip.lastCheckResult} | Slow: {trip.lastPathMetricsCheck && moment(trip.lastPathMetricsCheck).format('h:mm a')}
                                        </span>
                                    }
                                </Typography>
                                {
                                    trip?.issues?.issueString && trip.issues.issueString.length > 0 && trip.issues.issueString.map(str => {
                                        return <span style={{ color: 'red', fontSize: '0.7rem', ml: 1 }}>
                                            <b>Issue:</b> {str}
                                        </span>
                                    })
                                }
                            </Box>

                            <Tooltip
                                title={
                                    <Box sx={{
                                        p: 1,
                                        maxWidth: 300,
                                        boxShadow: 3,
                                        borderRadius: 1,
                                        backgroundColor: 'background.paper'
                                    }}>
                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                            <strong style={{ color: 'dodgerBlue' }}>
                                                {typeof trip?.route?.startLocation === 'string' ? trip?.route?.startLocation :
                                                    (typeof trip?.route?.startLocation === 'object' && trip?.route?.startLocation?.locationName ? trip?.route?.startLocation?.locationName : null)}
                                            </strong>
                                            <em style={{ color: 'orchid' }}>{trip?.route?.viaLocations?.map(loc => ` → ${typeof loc === 'string' ? loc : loc.locationName}`).join('')}</em>
                                            → <strong style={{ color: 'midnightblue' }}>
                                                {typeof trip?.route?.endLocation === 'string' ? trip?.route?.endLocation :
                                                    (typeof trip?.route?.endLocation === 'object' && trip?.route?.endLocation?.locationName ? trip?.route?.endLocation?.locationName : null)}
                                            </strong>
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 0.5, color: 'darkorange' }}>
                                            <strong>Distance:</strong> {trip?.route?.routeLength} KM
                                        </Typography>
                                    </Box>
                                }
                                arrow
                                placement="top-start"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: 'background.paper',
                                            color: 'text.primary',
                                            '& .MuiTooltip-arrow': {
                                                color: 'background.paper',
                                            },
                                            p: 0,
                                            boxShadow: 3,
                                            borderRadius: 1,
                                        }
                                    }
                                }}
                            >
                                <Typography variant="subtitle2" className="route-name">
                                    {isRoundTrip && (
                                        <Box component="span" sx={{ color: 'DodgerBlue', fontWeight: 700, mr: 0.5 }}>
                                            ↻
                                        </Box>
                                    )}
                                    <b>{routeDisplayName}</b> - {formatDateTime(trip?.plannedStartTime)}
                                </Typography>
                            </Tooltip>
                            {trip?.tripStage !== 'Completed' &&
                                <Box
                                    sx={{
                                        height: '4px',
                                        width: '100%',
                                        background: `linear-gradient(to right, RoyalBlue ${trip.completionPercentage}%, lightgray ${trip.completionPercentage}%)`,
                                        marginTop: 0.8,
                                        borderRadius: '2px'
                                    }}
                                />
                            }


                            {
                                trip?.tripStage !== 'Completed' && trip?.currentLocation?.name &&
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5, mt: 1 }}>
                                    <Icon path={mdiHexagon} size={0.6} style={{ marginRight: '1px' }} color={trip?.currentLocation?.type === 'startLocation' ? 'DodgerBlue' : trip?.currentLocation?.type === 'endLocation' ? 'Navy' : 'Orchid'} />
                                        <Typography variant="body1" className="location-name" sx={{ fontSize: '0.7rem' }}>
                                            {trip?.currentLocation?.name} | {trip?.currentLocation?.type === 'startLocation' ? 'Start' : trip?.currentLocation?.type === 'endLocation' ? 'End' : 'Stop'}
                                    </Typography>
                                </Box>
                            }
                            {/*
                                trip?.tripStage !== 'Completed' &&
                                <Typography variant="body1" className="active-status" sx={{ fontSize: '0.7rem', marginTop: 0.5 }}>
                                    {trip?.activeStatus}
                                </Typography>
                            */}
                            {
                                trip?.tripStage !== 'Completed' ? (trip?.tripStage === 'Cancelled' || trip?.tripStage === 'Aborted') ?
                                <Typography variant="body1" className="active-status" sx={{ fontSize: '0.7rem', marginTop: 0.5 }}>
                                    Cancelled - {trip?.abortReason}
                                </Typography> : <Typography variant="body1" className="active-status" sx={{ fontSize: '0.7rem', marginTop: 0.5 }}>
                                    Active Status: {trip?.activeStatus}
                                </Typography> :
                                <Typography variant="body1" className="active-status" sx={{ fontSize: '0.7rem', marginTop: 0.5 }}>
                                    Completed on {getISTDateTime(trip?.actualEndTime)}
                                </Typography>
                            }





                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start' }}>
                            <Typography
                                variant="h6"
                                className="trip-stage"
                                sx={{ marginRight: 1, fontSize: trip?.tripStage?.includes(' ') ? '0.7rem' : '0.8rem', textAlign: 'right', marginTop: 0.5, marginBottom: 0.5 }}>
                                {trip?.tripStage}
                            </Typography>
                            {
                                trip?.violationsCount > 0 ?
                                    <Typography variant="body1" className="violations" sx={{ fontSize: '0.7rem', marginRight: 1, textAlign: 'right' }}>
                                        ✗ {trip?.violationsCount} <br /> <i>Violations</i>
                                    </Typography> :
                                    <Typography variant="body1" className="rules-good" sx={{ fontSize: '0.7rem', marginRight: 1, textAlign: 'right' }}>
                                        <i> ✓ Rules<br /> Good</i>
                                </Typography>
                            }
                        </Box>
                    </Box>
                    {expandedTripId === trip._id &&
                        <Box sx={{ width: '100%' }}>
                            <Divider sx={{ bgcolor: 'white' }} />
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                                {(trip?.tripStage === 'Active' || trip?.tripStage === 'Planned' || trip?.tripStage === 'Start Delayed' || isAdmin) &&
                                    <IconButton
                                        size="small"
                                        onClick={() => handleDataViewOpen()}
                                        title="Current Situation"
                                        sx={{ color: 'white' }}
                                    >
                                        <Tooltip title="Current Situation">
                                            <Icon path={mdiListStatus} size={0.75} />
                                        </Tooltip>
                                    </IconButton>
                                }
                                <IconButton
                                    size="small"
                                    onClick={() => dispatch(setShowTripReport(true))}
                                    title="Trip Report"
                                    sx={{ color: 'white' }}
                                >
                                    <Tooltip title="Trip Report">
                                        <Icon path={mdiFileChart} size={0.75} />
                                    </Tooltip>
                                </IconButton>

                                {
                                    (trip?.tripStage === 'Active' || trip?.tripStage === 'Planned' || trip?.tripStage === 'Start Delayed') &&
                                    <IconButton
                                        size="small"
                                        onClick={() => setSettingsModalOpen(true)}
                                        title="Trip Settings"
                                        sx={{ color: 'white' }}
                                    >
                                        <Tooltip title="Trip Settings">
                                            <Icon path={mdiCog} size={0.75} />
                                        </Tooltip>
                                    </IconButton>
                                }
                                {
                                    trip.tripStage === 'Completed' &&
                                    <IconButton
                                        size="small"
                                        onClick={() => setSettingsModalOpen(true)}
                                        title="Route Revision"
                                        sx={{ color: 'white' }}
                                    >
                                        <Tooltip title="Route Revision">
                                                <Icon path={mdiRoutes} size={0.75} />
                                        </Tooltip>
                                    </IconButton>
                                }
                                <IconButton
                                    size="small"
                                    onClick={() => showTripOnMap(trip)}
                                    title="Close Trip"
                                    sx={{ color: 'white' }}
                                >
                                    <Tooltip title="Close Trip">
                                        <Icon path={mdiCloseCircle} size={0.75} />
                                    </Tooltip>
                                </IconButton>
                            </Box>
                        </Box>
                    }



                </Stack>
            </ListItem>
            <CancelTripDialog
                open={openCancelDialog}
                onClose={handleCancelClose}
                onConfirm={handleConfirmCancel}
                tripToCancel={tripToCancel}
                isCancelling={isCancelling}
            />
            <TripLogModal
                open={logModalOpen}
                onClose={() => setLogModalOpen(false)}
                tripName={trip.truckRegistrationNumber}
                tripId={trip.tripId}
            />
            <TripDataViewModal
                dataViewOpen={dataViewOpen}
                handleDataViewClose={handleDataViewClose}
                handleCancelClick={handleCancelClick}
                handleShowLog={handleShowLog}
                handleDownloadLog={handleDownloadLog}
                handleSettingsOpen={handleSettingsOpen}
                handleReprocess={handleReprocess}
                handleResetTrip={handleResetTrip}
                handleForceComplete={() => handleForceCompleteClick(trip)}
            />
            <TripSettingsModal
                open={settingsModalOpen}
                handleClose={handleSettingsClose}
            />
            <RouteDetailView
                open={routeDetailOpen}
                onClose={handleRouteDetailClose}
                routeid={selectedRoute?._id}
            />
            <ForceCompleteTripDialog
                open={forceCompleteDialogOpen}
                onClose={handleForceCompleteClose}
                onConfirm={handleConfirmForceComplete}
                trip={tripToForceComplete}
                isProcessing={isForceCompleting}
            />
        </>
    );
}, (prevProps, nextProps) => {
    return prevProps.tripData._id === nextProps.tripData._id &&
        prevProps.expandedTripId === nextProps.expandedTripId &&
        prevProps.tripData.completionPercentage === nextProps.tripData.completionPercentage;
});

export default TripListItem;
